/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { AuthService } from './services/auth.service';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbInputModule,
  NbAlertModule, NbIconModule,
  NbCheckboxComponent,
  NbCheckboxModule,
  NbCardModule,
  NbButtonModule, NbSpinnerModule, NbPopoverModule,
  NbThemeModule,
  NbTooltipModule
} from '@nebular/theme';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { LoginComponent } from './components/login/login.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VerifyOtpComponent } from './components/verify-otp/verify-otp.component';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TwoFactorAuthComponent } from './components/two-factor-auth/two-factor-auth.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { httpInterceptorProviders } from './services/interceptors';
import { NgbModalModule, NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
// import { environment } from '../environments/environment';

// const config: SocketIoConfig = { url: environment.api.socketUrl, options: {} };

@NgModule({
  declarations: [AppComponent, LoginComponent, SpinnerComponent, ForgotPasswordComponent,
    ResetPasswordComponent, VerifyOtpComponent, TwoFactorAuthComponent, ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule, NbIconModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbPaginationModule,
    NbCheckboxModule, NbPopoverModule,
    NbCardModule,
    // ChartsModule,

    NbButtonModule, NbSpinnerModule, MatSortModule,
    MatDialogModule,
    ThemeModule.forRoot(),
    NbInputModule, NbAlertModule, NbTooltipModule, MatCheckboxModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NbToastrModule.forRoot({
      preventDuplicates: true,
      duration: 3000,
    }),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    NbThemeModule.forRoot({ name: 'cosmic' }),
    CoreModule.forRoot(),

    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    // SocketIoModule.forRoot(config)
  ],


  providers: [AuthService, { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    httpInterceptorProviders,
    JwtHelperService, ThemeService],
  bootstrap: [AppComponent],

})
export class AppModule {
}
